import ApiHelper from "../../../util/api/ApiHelper";
import { APPLICATION_SERVER } from "../../../constants";
import AuthRepository from "../../../domain/repositories/auth/AuthRepository";
import ChangeListenerList from "../../../util/ChangeListenerList";
import ChangeListener from "../../../util/ChangeListener";
import RequestOptions from "../../../util/api/RequestOptions";
import authResponse from "../../../domain/models/auth/AuthResponse";

export default class AuthRepositoryImpl implements AuthRepository {
  private USER_TOKEN_KEY = "token";
  private USER_ROLE_KEY = "role";
  private authListeners: ChangeListenerList;

  public constructor() {
    this.authListeners = new ChangeListenerList();
  }

  public getAccessToken = (): string => {
    if (!this.isAuthorized()) {
      throw new Error("User is not authorized");
    }
    return localStorage.getItem(this.USER_TOKEN_KEY) || "";
  };

  public getUserRole = (): "user" | "admin" => {
    if (!this.isAuthorized()) {
      throw new Error("User is not authorized");
    }
    return localStorage.getItem(this.USER_ROLE_KEY) as "user" | "admin";
  };

  public isAuthorized = (): boolean => {
    return !!localStorage.getItem(this.USER_TOKEN_KEY);
  };

  public addAuthListener = (listener: ChangeListener): void => {
    this.authListeners.addListener(listener);
  };

  public removeAuthListener = (listener: ChangeListener): void => {
    this.authListeners.removeListener(listener);
  };

  public signIn = async (email: string, password: string): Promise<void> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.setBody(
      JSON.stringify({
        email,
        password,
      })
    );

    return ApiHelper.fetchPostJson<authResponse>(`${APPLICATION_SERVER}/api/auth`, requestOptions).then((response) => {
      if (response.authenticated) {
        localStorage.setItem(this.USER_ROLE_KEY, response.role);
        localStorage.setItem(this.USER_TOKEN_KEY, response.token);
        this.authListeners.notifyListenersAboutChange();
      } else {
        throw new Error("Not authorized");
      }
    });
  };

  public logout = (): void => {
    localStorage.setItem(this.USER_ROLE_KEY, "");
    localStorage.setItem(this.USER_TOKEN_KEY, "");
    this.authListeners.notifyListenersAboutChange();
  };

  public sendRestorePassword = (email: string): Promise<void> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.setBody(JSON.stringify({ email }));

    return ApiHelper.fetchPostJson<authResponse>(`${APPLICATION_SERVER}/api/restore-password`, requestOptions).then(
      () => {
        /* empty */
      }
    );
  };
}
